(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const input = root.querySelector('[data-name-input]');
    const font = root.querySelector('[data-font]');
    const dialog = root.querySelector('[data-personalizer-dialog]');
    const previews = [...root.querySelectorAll('[data-name-preview]')];
    const error = root.querySelector('[data-name-error]');
    const birthInputs = [...root.querySelectorAll('[data-birth-input]')];
    const birthPreviews = [...root.querySelectorAll('[data-birth-preview]')];
    const birthValue = field => {
      const value = root.querySelector(`[data-birth-input="${field}"]`)?.value || '';
      if (!value) return '';
      if (field === 'date') {
        const [year, month, day] = value.split('-');
        return year && month && day ? `${day}.${month}.${year}` : '';
      }
      if (field === 'weight') return `${value} g`;
      if (field === 'length') return `${value.replace('.', ',')} cm`;
      return value;
    };
    const renderBirth = () => {
      context.font = '100px "Baloo"';
      birthPreviews.forEach(preview => {
        const value = birthValue(preview.dataset.birthPreview);
        preview.textContent = value;
        const width = preview.parentElement.clientWidth;
        const maxSize = width * Number(preview.dataset.birthSize) / 100;
        const measured = context.measureText(value).width;
        preview.style.fontSize = `${measured ? Math.min(maxSize, 100 * preview.clientWidth * .96 / measured) : maxSize}px`;
      });
    };
    const context = document.createElement('canvas').getContext('2d');
    const openButton = root.querySelector('[data-open-personalizer]');
    let revision = 0;
    const render = async () => {
      const current = ++revision;
      renderBirth();
      const family = font.value;
      const color = root.querySelector('[data-color]:checked');
      const name = input.value.trim();
      font.style.fontFamily = `"${family}"`;
      root.querySelector('[data-color-code]').value = color.dataset.color;
      root.querySelector('[data-name-count]').textContent = input.value.length;
      if (name) root.querySelector('[data-summary]').textContent = `${name} · ${family} · ${color.value}`;
      previews.forEach(preview => {
        preview.textContent = name;
        preview.style.color = color.dataset.color;
        preview.style.fontFamily = `"${family}"`;
      });
      try { await document.fonts.load(`100px "${family}"`); } catch (_) {}
      if (current !== revision) return;
      renderBirth();
      context.font = `100px "${family}"`;
      const measurement = context.measureText(name);
      const textWidth = Math.max(measurement.width, (measurement.actualBoundingBoxLeft || 0) + (measurement.actualBoundingBoxRight || 0));
      const x = parseFloat(root.style.getPropertyValue('--name-x'));
      previews.forEach(preview => {
        const imageWidth = preview.parentElement.clientWidth;
        const safeWidth = imageWidth * Math.min(x, 100 - x) * .02;
        const targetWidth = Math.min(preview.clientWidth, safeWidth) * .98;
        const maxSize = imageWidth * Number(root.dataset.maxSize) / 100;
        preview.style.fontSize = `${textWidth ? Math.min(maxSize, 100 * targetWidth / textWidth) : maxSize}px`;
      });
    };
    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    const gallery = root.querySelector('[data-gallery]');
    let activeIndex = 0;
    const showSlide = index => {
      activeIndex = (Number(index) + slides.length) % slides.length;
      index = activeIndex;
      const counter = root.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      root.querySelectorAll('[data-gallery-slide]').forEach(slide => slide.hidden = slide.dataset.gallerySlide !== String(index));
      root.querySelectorAll('[data-gallery-button]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.galleryButton === String(index))));
      render();
    };
    const open = () => {
      if (!dialog.open) dialog.showModal();
      render();
      input.focus({preventScroll: true});
    };
    const validName = () => {
      input.value = input.value.trim();
      const valid = Boolean(input.value) && input.value.length <= 15;
      error.hidden = valid;
      error.textContent = valid ? '' : root.dataset.requiredMessage;
      input.setAttribute('aria-invalid', String(!valid));
      if (!valid) { open(); input.focus(); }
      if (!valid) return false;
      const invalidExtra = [...root.querySelectorAll('[data-extra-required]')].find(field => !field.checkValidity());
      if (invalidExtra) { open(); invalidExtra.focus(); invalidExtra.reportValidity(); return false; }
      return true;
    };
    openButton.addEventListener('click', open);
    root.querySelector('[data-close-personalizer]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => openButton.focus({preventScroll: true}));
    root.querySelector('[data-apply-personalizer]').addEventListener('click', () => {
      if (!validName()) return;
      showSlide(root.dataset.personalImage);
      dialog.close();
    });
    input.addEventListener('input', () => {
      error.hidden = true;
      input.removeAttribute('aria-invalid');
      render();
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Enter') { event.preventDefault(); root.querySelector('[data-apply-personalizer]').click(); }
    });
    birthInputs.forEach(field => field.addEventListener('input', render));
    birthInputs.forEach(field => field.addEventListener('change', render));
    font.addEventListener('change', render);
    root.querySelectorAll('[data-color]').forEach(radio => radio.addEventListener('change', render));
    root.querySelectorAll('[data-gallery-button]').forEach(button => button.addEventListener('click', () => showSlide(button.dataset.galleryButton)));
    root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    gallery.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    root.querySelector('[data-variant]').addEventListener('change', event => {
      const option = event.target.selectedOptions[0];
      const button = root.querySelector('[data-submit]');
      root.querySelector('[data-price]').textContent = option.dataset.price;
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? root.dataset.unavailableLabel : root.dataset.cartLabel;
    });
    form.addEventListener('submit', event => {
      if (!validName()) event.preventDefault();
      render();
    });
    const observer = new ResizeObserver(render);
    previews.forEach(preview => observer.observe(preview.parentElement));
    showSlide(root.dataset.personalImage);
  };
  document.querySelectorAll('[data-mdh-personalizer]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mdh-personalizer]').forEach(init));
})();


